import React from 'react';
import './FindYourPerfectHome.css';

const FindYourPerfectHome = () => {
 
  const phoneNumber = "919934822681"; 
  const message = "Hello, I want to connect with you."; 

  const handleClick = () => {
    const url = `https://wa.me/${phoneNumber}?text=${encodeURIComponent(message)}`;
    window.open(url, "_blank"); // New tab में खुलेगा
  };
  return (
    <div className="container">
      <h2 className="heading">Find Your Perfect Home</h2>
      <div className="card-container">
        {/* First Card */}
        <div className="card">
          <div className="card-image-wrapper">
            <img
              src="https://websitedemos.net/real-estate-02/wp-content/uploads/sites/430/2020/01/estate-modern-apartment.jpg"
              alt="Modern Apartment"
            />
            <button className="card-badge" onClick={handleClick}>For Sale</button>
          </div>
          <h4>2 BHK Apartment 1100 Sq Ft</h4>
          {/*<p>$ 1500/mo</p>*/}
      
        </div>

        {/* Second Card */}
        <div className="card">
          <div className="card-image-wrapper">
            <img
              src="https://websitedemos.net/real-estate-02/wp-content/uploads/sites/430/2020/01/estate-family-home.jpg"
              alt="Family Home"
            />
            <button onClick={handleClick} className="card-badge" style={{ backgroundColor: '#f6bc98' }}>
              For Sale
            </button>
          </div>
          <h4>3 BHK Apartment 1300 Sq Ft</h4>
         {/* <p>$ 175,000</p>*/}
        
        </div>

        {/* Third Card */}
        <div className="card">
          <div className="card-image-wrapper">
            <img
              src="https://websitedemos.net/real-estate-02/wp-content/uploads/sites/430/2020/02/modern-apartment.jpg"
              alt="Affordable Options"
            />
            <button className="card-badge" onClick={handleClick}>For Sale</button>
          </div>
          <h4>Commercial Apartment 2000 Sq Ft</h4>
          {/*<p>$ 175,000</p>*/}
       
        </div>
        {/**fourth container */}
        
      </div>
    </div>
  );
};

export default FindYourPerfectHome;
